/** En kıdemli beş başkan sayfası — video kaynağı */
export const SENIOR_FIVE_PRESIDENTS_VIDEO_URL =
    'https://istanbulrotary.org/img/video/en_kidemli_bes_baskan.mp4';
